import { BigNumber as BigNumberDefault } from 'bignumber.js';

export const BigNumber = BigNumberDefault.clone({ DECIMAL_PLACES: 12, ROUNDING_MODE: BigNumberDefault.ROUND_CEIL });
export type BigNumberType = BigNumberDefault;
export type BigNumberParseable = BigNumberDefault.Value;

export default BigNumber;
